import React, { FC } from "react";

import { SVGIconComponentProps } from "~/common/types/common";
import { errorRed } from "../colors/colors";

export const WarningTriangle: FC<SVGIconComponentProps> = ({
  color = errorRed,
  className,
  size = "36",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" width="36" height="36" rx="18" fill={color} />
      <path
        d="M12.6262 21.6281L17.012 12.8806C17.627 11.6541 19.3776 11.6545 19.9921 12.8811L24.3739 21.6287C24.9291 22.7369 24.1233 24.0418 22.8838 24.0418H14.1161C12.8763 24.0418 12.0705 22.7364 12.6262 21.6281Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 16.334V18.0007"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9173 21.3327C18.9173 21.5628 18.7308 21.7493 18.5007 21.7493C18.2705 21.7493 18.084 21.5628 18.084 21.3327C18.084 21.1026 18.2705 20.916 18.5007 20.916C18.7308 20.916 18.9173 21.1026 18.9173 21.3327Z"
        stroke="white"
      />
    </svg>
  );
};
